/* eslint-disable react/prop-types */
import {
  Button,
  Col,
  DatePicker,
  Form,
  Input,
  Menu,
  Modal,
  Progress,
  Row,
  Spin,
  notification,
} from 'antd';
import {
  CheckCircleOutlined,
  CloseCircleOutlined,
  DownloadOutlined,
  FileExcelOutlined,
  RedoOutlined,
} from '@ant-design/icons';
import {
  deleteHistoricoDeSindicato,
  descargarPlantillaHistoricoDeSindicato,
  getHistoricosDeSindicatoVistaOptimizada,
  importarHistoricoDeSindicato,
  patchHistoricoDeSindicato,
  postHistoricoDeSindicato,
} from 'api/catalogos/historicoDeSindicatos';
import { getSindicatos } from 'api/catalogos/sindicatos';
import { getDatoOperacionalPorEmpleado } from 'api/estructuraOrganizacional/datosOperacionalesDeEmpleados';
import { getPeriodosFiscales } from 'api/configuraciones/periodosFiscales';
import { getPeriodosDeNominasDetalles } from 'api/nominas/periodos/periodosDeNominasDetalle';
import { getPeriodosDeNominas } from 'api/nominas/periodos/periodosDeNominas';
import { getConfiguracionDescuentos } from 'api/nominas/descuentos/configuracionDescuentos';
import { getEmpleadosvistaOptimized } from 'api/estructuraOrganizacional/empleados';
import getProcesoEnCursoTerminado from 'api/catalogos/ProcesoEnCursoTerminado';
import { checkToken } from 'api/utils';
import Dragger from 'components/Dragger';
import FormSubmitControls from 'components/FormSubmitControls';
import ModalConfirmation from 'components/ModalConfirmation';
import ModalDelete from 'components/ModalDelete';
import Select from 'components/Select';
import Table from 'components/Table';
import moment from 'moment';
import React, { useEffect, useRef, useState } from 'react';
import {
  ESTATUS_ACTIVO,
  ESTATUS_AUTORIZADO,
  ESTATUS_CANCELADO,
} from 'utils/constants';
import exportarExcelDesdeColumnas from 'utils/exportarExcelDesdeColumnas';
import { formatReceived } from 'utils/formatValues';
import { onError } from 'utils/handlers';

export const historicodesindicatoPermission = {
  permissionModel: 'historicodesindicato',
  catalogsModels: [],
  tabsModels: [],
};

const DESCRIPCION_PROCESO_IMPORTAR = 'Importar Historico De Sindicato';

const HistoricoSindicato = ({ permission }) => {
  const [form] = Form.useForm();
  const [formHistorial] = Form.useForm();
  const [formCarga] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [exportandoTodos, setExportandoTodos] = useState(false);
  const [empleados, setEmpleados] = useState([]);
  const [sindicatos, setSindicatos] = useState([]);
  const [descuentos, setDescuentos] = useState([]);
  const [periodosFiscales, setPeriodosFiscales] = useState([]);
  const [periodosDeNominasDetalles, setPeriodosDeNominasDetalles] = useState([]);
  const [periodosDeNominas, setPeriodosDeNominas] = useState([]);
  const [data, setData] = useState([]);
  const [tipoNominaEmpleadoId, setTipoNominaEmpleadoId] = useState();

  const [selectedKeys, setSelectedKeys] = useState([]);
  const [selectedRecord, setSelectedRecord] = useState(null);

  const [visibleModal, setVisibleModal] = useState(false);
  const [visibleFormModal, setVisibleFormModal] = useState(false);
  const [visibleDelete, setVisibleDelete] = useState(false);
  const [visibleAutorizar, setVisibleAutorizar] = useState(false);
  const [visibleCancelar, setVisibleCancelar] = useState(false);
  const [visibleReactivar, setVisibleReactivar] = useState(false);

  const [isPollingImport, setIsPollingImport] = useState(false);
  const [progresoImport, setProgresoImport] = useState({ en_curso: 0, total: 0 });
  const pollingImportRef = useRef(null);

  const sindicatoSeleccionado = Form.useWatch('sindicato', formHistorial);
  const periodoSeleccionado = Form.useWatch('periodo', formHistorial);

  const descuentoDelSindicato = descuentos.find(
    (d) => d.id === sindicatos.find((s) => s.id === sindicatoSeleccionado)?.descuento,
  );
  const requierePeriodoDeDescuento = !!descuentoDelSindicato;

  const periodosDeNominasDetallesFiltrados = periodosDeNominasDetalles.filter((detalle) => {
    const periodoDeNomina = periodosDeNominas.find((pdn) => pdn.id === detalle.periodo_de_nomina);
    if (!periodoDeNomina) return false;
    if (periodoSeleccionado && periodoDeNomina.periodo_fiscal !== periodoSeleccionado) {
      return false;
    }
    // Solo periodos del calendario (Plantilla/Eventuales/etc.) que
    // corresponde al Tipo de Nómina Empleado real del empleado seleccionado
    // -- de lo contrario el motor de cálculo nunca hace coincidir el
    // periodo_de_nomina_detalle_id elegido (comparación exacta de id).
    if (tipoNominaEmpleadoId && periodoDeNomina.tipo_de_nomina_empleado !== tipoNominaEmpleadoId) {
      return false;
    }
    return true;
  });

  useEffect(() => {
    let mounted = true;
    const fetchAll = async () => {
      setLoading(true);
      await checkToken();
      const [
        _empleados,
        _sindicatos,
        _descuentos,
        _periodosFiscales,
        _periodosDeNominasDetalles,
        _periodosDeNominas,
      ] = await Promise.all([
        getEmpleadosvistaOptimized(),
        getSindicatos(),
        getConfiguracionDescuentos(),
        getPeriodosFiscales(),
        getPeriodosDeNominasDetalles(),
        getPeriodosDeNominas(),
      ]);
      if (mounted) {
        setEmpleados(_empleados);
        setSindicatos(_sindicatos);
        setDescuentos(_descuentos);
        setPeriodosFiscales(_periodosFiscales);
        setPeriodosDeNominasDetalles(_periodosDeNominasDetalles);
        setPeriodosDeNominas(_periodosDeNominas);
        setLoading(false);
      }
    };
    fetchAll();
    return () => { mounted = false; };
  }, []);

  const reload = async () => {
    const empId = form.getFieldValue('empleado');
    if (!empId) return;
    const raw = await getHistoricosDeSindicatoVistaOptimizada({ empleado_id: empId });
    const list = raw?.results || raw || [];
    setData(formatReceived(list));
  };

  useEffect(() => {
    if (!isPollingImport) return () => {};

    let intentos = 0;
    const maxIntentos = 340;

    pollingImportRef.current = setInterval(async () => {
      try {
        intentos += 1;
        const lista = await getProcesoEnCursoTerminado({
          descripcion: DESCRIPCION_PROCESO_IMPORTAR,
        });
        const proceso = lista[0];

        if (proceso) {
          setProgresoImport({
            en_curso: proceso.registro_en_curso || 0,
            total: proceso.total_registros || 0,
          });
        }

        const termino = proceso && proceso.procesando === false;
        if (termino || intentos >= maxIntentos) {
          clearInterval(pollingImportRef.current);
          pollingImportRef.current = null;
          setIsPollingImport(false);
          setProgresoImport({ en_curso: 0, total: 0 });

          if (proceso?.resultado) {
            const byteCharacters = atob(proceso.resultado);
            const byteArray = new Uint8Array(byteCharacters.length);
            for (let i = 0; i < byteCharacters.length; i += 1) {
              byteArray[i] = byteCharacters.charCodeAt(i);
            }
            const blob = new Blob([byteArray], {
              type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            });
            const url = URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.download = 'Historico_Sindicato_Resultado.xlsx';
            link.click();
            URL.revokeObjectURL(url);
          }

          notification.success({
            message: 'Importación completada',
            description: 'La carga masiva de Histórico de Sindicato finalizó. Se descargó el archivo de resultado.',
            placement: 'topRight',
            duration: 6,
          });
          await reload();
        }
      } catch (_err) {
        // No se interrumpe el polling: el siguiente tick reintenta. Si el
        // error es por sesión expirada, utils/api.js ya avisó y cerró
        // sesión; aquí solo dejamos rastro para diagnóstico.
        // eslint-disable-next-line no-console
        console.error('[polling importación histórico de sindicato] error al consultar estado', _err);
      }
    }, 2000);

    return () => {
      if (pollingImportRef.current) {
        clearInterval(pollingImportRef.current);
        pollingImportRef.current = null;
      }
    };
  }, [isPollingImport]);

  const onChangeEmpleado = async (empId) => {
    setSelectedKeys([]);
    setSelectedRecord(null);
    if (empId) {
      const [raw, datoOp] = await Promise.all([
        getHistoricosDeSindicatoVistaOptimizada({ empleado_id: empId }),
        getDatoOperacionalPorEmpleado(empId),
      ]);
      const list = raw?.results || raw || [];
      setData(formatReceived(list));
      setTipoNominaEmpleadoId(datoOp?.tipo_de_nomina_empleado || undefined);
    } else {
      setData([]);
      setTipoNominaEmpleadoId(undefined);
    }
  };

  const onClickPlantilla = async () => {
    try {
      setLoading(true);
      await descargarPlantillaHistoricoDeSindicato();
    } finally {
      setLoading(false);
    }
  };

  const openModal = () => {
    formCarga.resetFields();
    setVisibleModal(true);
  };

  const closeModal = () => {
    setVisibleModal(false);
    formCarga.resetFields();
  };

  const menuImport = (
    <Menu
      items={[
        {
          key: 1,
          label: 'Obtener Plantilla',
          icon: <FileExcelOutlined />,
          onClick: onClickPlantilla,
        },
        {
          key: 2,
          label: 'Cargar',
          icon: <DownloadOutlined />,
          onClick: openModal,
        },
      ]}
    />
  );

  const onUpload = async () => {
    try {
      await formCarga.validateFields();
      const { file } = formCarga.getFieldsValue();
      if (file) {
        setLoading(true);
        const response = await importarHistoricoDeSindicato(file.file);
        if (response?.status === 202) {
          setVisibleModal(false);
          formCarga.resetFields();
          setProgresoImport({ en_curso: 0, total: 0 });
          setIsPollingImport(true);
        }
      }
      setLoading(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };

  const handleAdd = () => {
    setSelectedRecord(null);
    formHistorial.resetFields();
    setVisibleFormModal(true);
  };

  const handleEdit = () => {
    if (!selectedRecord) return;
    formHistorial.setFieldsValue({
      sindicato: selectedRecord.sindicato_id,
      fecha_inicial: selectedRecord.fecha_inicial ? moment(selectedRecord.fecha_inicial) : null,
      fecha_final: selectedRecord.fecha_final ? moment(selectedRecord.fecha_final) : null,
      solicitud: selectedRecord.solicitud,
      periodo: selectedRecord.periodo_id,
      periodo_de_nomina_detalle: selectedRecord.periodo_de_nomina_detalle_id,
    });
    setVisibleFormModal(true);
  };

  const onFinishHistorial = async () => {
    try {
      await formHistorial.validateFields();
    } catch {
      return;
    }
    const empId = form.getFieldValue('empleado');
    if (!empId) return;
    const values = formHistorial.getFieldsValue();
    const payload = {
      empleado: empId,
      sindicato: values.sindicato,
      fecha_inicial: values.fecha_inicial?.format('YYYY-MM-DD'),
      fecha_final: values.fecha_final?.format('YYYY-MM-DD') || null,
      solicitud: values.solicitud,
      periodo: values.periodo || null,
      periodo_de_nomina_detalle: values.periodo_de_nomina_detalle || null,
    };
    if (selectedRecord) {
      // Sin esto, el serializer (CustomModelSerializerMixin.validate) resetea
      // estados_globales a Activo cuando el campo no viene en el payload.
      payload.estados_globales = selectedRecord.estados_globales_id;
    }
    setLoading(true);
    const ok = selectedRecord
      ? await patchHistoricoDeSindicato(selectedRecord.id, payload)
      : await postHistoricoDeSindicato(payload);
    if (ok) {
      setVisibleFormModal(false);
      formHistorial.resetFields();
      setSelectedRecord(null);
      setSelectedKeys([]);
      await reload();
    }
    setLoading(false);
  };

  const confirmDelete = async () => {
    if (!selectedRecord) return;
    setLoading(true);
    const ok = await deleteHistoricoDeSindicato(selectedRecord.id);
    if (ok) {
      setVisibleDelete(false);
      setSelectedRecord(null);
      setSelectedKeys([]);
      await reload();
    }
    setLoading(false);
  };

  const cambiarEstadosGlobales = async (estadosGlobales, setVisible) => {
    if (!selectedRecord) return;
    setLoading(true);
    const ok = await patchHistoricoDeSindicato(selectedRecord.id, {
      estados_globales: estadosGlobales,
    });
    if (ok) {
      setVisible(false);
      await reload();
    }
    setLoading(false);
  };

  const onConfirmAutorizar = () => cambiarEstadosGlobales(ESTATUS_AUTORIZADO, setVisibleAutorizar);
  const onConfirmCancelar = () => cambiarEstadosGlobales(ESTATUS_CANCELADO, setVisibleCancelar);
  const onConfirmReactivar = () => cambiarEstadosGlobales(ESTATUS_ACTIVO, setVisibleReactivar);

  const columns = [
    {
      titleText: 'Sindicato',
      dataIndex: 'sindicato_clave',
      key: 'sindicato',
      width: 260,
      render: (val, record) => (val ? `${val} - ${record.sindicato_descripcion}` : record.sindicato_descripcion),
    },
    {
      titleText: 'Descuento',
      dataIndex: 'sindicato_descuento_clave_y_concepto',
      key: 'sindicato_descuento',
      width: 260,
      render: (val) => val || '',
    },
    {
      titleText: 'Fecha Inicial',
      dataIndex: 'fecha_inicial',
      key: 'fecha_inicial',
      width: 130,
      render: (val) => (val ? moment(val).format('DD/MM/YYYY') : ''),
    },
    {
      titleText: 'Fecha Final',
      dataIndex: 'fecha_final',
      key: 'fecha_final',
      width: 130,
      render: (val) => (val ? moment(val).format('DD/MM/YYYY') : 'Vigente'),
    },
    {
      titleText: 'Solicitud',
      dataIndex: 'solicitud',
      key: 'solicitud',
      width: 200,
    },
    {
      titleText: 'Periodo',
      dataIndex: 'periodo_periodo',
      key: 'periodo',
      width: 100,
      render: (val) => val || '',
    },
    {
      titleText: 'Periodo de Nómina Inicial del Descuento',
      dataIndex: 'periodo_de_nomina_detalle_numero_de_nomina',
      key: 'periodo_de_nomina_detalle',
      width: 240,
      render: (val, record) => (val ? `${val} (${moment(record.periodo_de_nomina_detalle_fecha_inicial).format('YYYY-MM-DD')} al ${moment(record.periodo_de_nomina_detalle_fecha_final).format('YYYY-MM-DD')})` : ''),
    },
    {
      titleText: 'Estatus',
      dataIndex: 'estados_globales_descripcion',
      key: 'estados_globales_descripcion',
      width: 100,
    },
  ];

  const onClickExportarTodos = async () => {
    setExportandoTodos(true);
    const raw = await getHistoricosDeSindicatoVistaOptimizada();
    const list = raw?.results || raw || [];
    exportarExcelDesdeColumnas(
      formatReceived(list),
      columns,
      'Historico_de_Sindicato',
    );
    setExportandoTodos(false);
  };

  const requiredRule = { required: true, message: 'El campo es requerido' };
  const rules = { required: [requiredRule] };

  return (
    <Row className="container">
      <Spin tip="Cargando..." spinning={loading}>
        <Form layout="vertical" form={form} name="general">
          <Row gutter={10}>
            <Col xs={24} sm={12}>
              <Form.Item name="empleado" label="No. de Empleado">
                <Select
                  keyProp="id"
                  labelProp="numero_y_nombre_completo"
                  dataSource={empleados}
                  onChange={onChangeEmpleado}
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={6}>
              <Form.Item label=" ">
                <Button
                  icon={<FileExcelOutlined />}
                  loading={exportandoTodos}
                  onClick={onClickExportarTodos}
                >
                  Exportar Todos
                </Button>
              </Form.Item>
            </Col>
          </Row>
        </Form>

        <Table
          cols={columns}
          data={data}
          allowExportPDF={false}
          permission={permission}
          allowCustomImport
          customImportMenu={menuImport}
          customImportText="Importar Histórico Sindicato"
          rowSelection={{
            selectedRowKeys: selectedKeys,
            onChange: (keys, rows) => {
              setSelectedKeys(keys);
              setSelectedRecord(rows[0] || null);
            },
            type: 'radio',
          }}
          handleOnRowClick={(record) => {
            setSelectedKeys([record.id]);
            setSelectedRecord(record);
          }}
          controls={{
            onClickAdd: handleAdd,
            onClickEdit: handleEdit,
            onClickDelete: () => setVisibleDelete(true),
          }}
          disableDelete={!!selectedRecord && selectedRecord.estados_globales_id !== ESTATUS_ACTIVO}
          customActions={[
            {
              permission: { model: 'historicodesindicato', action: 'autorizar' },
              onClick: () => setVisibleAutorizar(true),
              icon: <CheckCircleOutlined />,
              text: 'Autorizar',
              className: 'success',
              disabled: !selectedRecord
                || selectedRecord.estados_globales_id === ESTATUS_AUTORIZADO,
            },
            {
              permission: { model: 'historicodesindicato', action: 'cancelar' },
              onClick: () => setVisibleCancelar(true),
              icon: <CloseCircleOutlined />,
              text: 'Cancelar',
              className: 'cancel',
              disabled: !selectedRecord || selectedRecord.estados_globales_id === ESTATUS_CANCELADO,
            },
            {
              permission: { model: 'historicodesindicato', action: 'reactivar' },
              onClick: () => setVisibleReactivar(true),
              icon: <RedoOutlined />,
              text: 'Reactivar',
              className: 'success',
              disabled: !selectedRecord || selectedRecord.estados_globales_id === ESTATUS_ACTIVO,
            },
          ]}
        />

        {/* Modal Add / Edit */}
        <Modal
          open={visibleFormModal}
          title={(
            <FormSubmitControls
              label={selectedRecord ? 'Editar Histórico Sindicato' : 'Agregar Histórico Sindicato'}
              onFinish={onFinishHistorial}
              onCancel={() => {
                setVisibleFormModal(false);
                formHistorial.resetFields();
              }}
              loading={loading}
            />
          )}
          footer={null}
          onCancel={() => {
            setVisibleFormModal(false);
            formHistorial.resetFields();
          }}
          closable={false}
          maskClosable={!loading}
          keyboard={!loading}
          destroyOnClose
        >
          <Form form={formHistorial} layout="vertical" onFinish={onFinishHistorial}>
            <Row gutter={16}>
              <Col xs={24} sm={24}>
                <Form.Item
                  name="sindicato"
                  label="Sindicato"
                  rules={rules.required}
                  hasFeedback
                >
                  <Select
                    labelProp="descripcion"
                    keyProp="id"
                    dataSource={sindicatos}
                    disabled={!!selectedRecord}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24}>
                <Form.Item label="Descuento">
                  <Input disabled value={descuentoDelSindicato?.clave_y_concepto || ''} />
                </Form.Item>
              </Col>
              <Col xs={24} sm={12}>
                <Form.Item
                  name="fecha_inicial"
                  label="Fecha Inicial"
                  rules={rules.required}
                  hasFeedback
                >
                  <DatePicker style={{ width: '100%' }} format="DD/MM/YYYY" />
                </Form.Item>
              </Col>
              <Col xs={24} sm={12}>
                <Form.Item name="fecha_final" label="Fecha Final (vacío = vigente)">
                  <DatePicker style={{ width: '100%' }} format="DD/MM/YYYY" />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24}>
                <Form.Item
                  name="solicitud"
                  label="Solicitud"
                  rules={rules.required}
                  hasFeedback
                >
                  <Input allowClear maxLength={150} />
                </Form.Item>
              </Col>
              <Col xs={24} sm={12}>
                <Form.Item
                  name="periodo"
                  label="Periodo"
                  rules={requierePeriodoDeDescuento ? rules.required : []}
                  hasFeedback
                >
                  <Select
                    dataSource={periodosFiscales}
                    allowClear
                    onChange={() => formHistorial.setFieldValue('periodo_de_nomina_detalle', undefined)}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={12}>
                <Form.Item
                  name="periodo_de_nomina_detalle"
                  label="Periodo de Nómina Inicial del Descuento"
                  rules={requierePeriodoDeDescuento ? rules.required : []}
                  hasFeedback
                >
                  <Select
                    keyProp="id"
                    dataSource={periodosDeNominasDetallesFiltrados}
                    render={(p) => `${p?.numero_de_nomina} (${p?.fecha_inicial} al ${p?.fecha_final})`}
                    allowClear
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24}>
                <Form.Item label="Estatus">
                  <Input
                    disabled
                    value={selectedRecord ? selectedRecord.estados_globales_descripcion : 'Activo'}
                  />
                </Form.Item>
              </Col>
            </Row>
          </Form>
        </Modal>

        {/* Modal Eliminar */}
        <ModalDelete
          open={visibleDelete}
          onCancel={() => setVisibleDelete(false)}
          onDelete={confirmDelete}
          content={selectedRecord?.sindicato_descripcion || ''}
          loading={loading}
        />

        {/* Modal Autorizar */}
        <ModalConfirmation
          onFinish={onConfirmAutorizar}
          ConfirmAutorize
          onCancel={() => setVisibleAutorizar(false)}
          contentTitle="Autorizar Histórico Sindicato"
          open={visibleAutorizar}
          loading={loading}
        />

        {/* Modal Cancelar */}
        <ModalConfirmation
          onFinish={onConfirmCancelar}
          ConfirmCancel
          onCancel={() => setVisibleCancelar(false)}
          contentTitle="Cancelar Histórico Sindicato"
          open={visibleCancelar}
          loading={loading}
        />

        {/* Modal Reactivar */}
        <ModalConfirmation
          onFinish={onConfirmReactivar}
          onFinishText="Reactivar"
          onFinishIcon={<RedoOutlined />}
          onCancel={() => setVisibleReactivar(false)}
          contentTitle="Reactivar Histórico Sindicato"
          open={visibleReactivar}
          loading={loading}
        />

        {/* Modal Import Excel */}
        <Modal
          open={visibleModal}
          title={(
            <FormSubmitControls
              label="Importar Histórico Sindicato"
              onFinish={onUpload}
              onCancel={closeModal}
              loading={loading}
            />
          )}
          onCancel={closeModal}
          footer={null}
          closable={false}
          maskClosable={!loading}
          keyboard={!loading}
          forceRender
          destroyOnClose
        >
          <Spin tip="Cargando..." spinning={loading}>
            <Form layout="vertical" form={formCarga} name="carga" onFinish={onUpload}>
              <Dragger
                label="Archivo"
                limitMB={30}
                rules={[{ required: true, message: 'El archivo es requerido' }]}
                name="file"
                allowedExtensions={['xlsx', 'xls']}
              />
            </Form>
          </Spin>
        </Modal>

        {/* Modal Progreso Importación */}
        <Modal
          open={isPollingImport}
          title="Importando Histórico Sindicato..."
          footer={null}
          closable={false}
          maskClosable={false}
          centered
        >
          <div style={{ textAlign: 'center', padding: '16px 0' }}>
            <Progress
              type="circle"
              percent={
                progresoImport.total > 0
                  ? Math.round((progresoImport.en_curso / progresoImport.total) * 100)
                  : 0
              }
            />
            <p style={{ marginTop: 16 }}>
              {progresoImport.en_curso}
              {' / '}
              {progresoImport.total}
              {' registros procesados'}
            </p>
          </div>
        </Modal>
      </Spin>
    </Row>
  );
};

export default HistoricoSindicato;
